module.exports = __webpack_public_path__ + "img/avatar-18.390d141b.png";